var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[(_vm.loading)?_c('b-spinner',{attrs:{"variant":_vm.variant,"label":"Spinning"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }